import { Component, ChangeDetectionStrategy, Inject, Injectable, Input, ChangeDetectorRef, ElementRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, of, Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { switchMap, filter, takeUntil } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from 'ngx-device-detector';
import * as ɵngcc5 from '@angular/platform-browser';

function ShareDialogComponent_div_3_fs_share_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fs-share-button", 6);
} if (rf & 2) {
    const platform_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("platform", platform_r3)("title", ctx_r2.shareConfig.title)("url", ctx_r2.shareConfig.url)("image", ctx_r2.shareConfig.image)("size", 20)("description", ctx_r2.shareConfig.description)("showIcon", true)("showLabel", false)("open", ctx_r2.open)("size", 150)("shape", "circle");
} }
function ShareDialogComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, ShareDialogComponent_div_3_fs_share_button_1_Template, 1, 11, "fs-share-button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.buttonPlatforms);
} }
function ShareDialogComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "fs-share", 10)(5, "button", 11);
    ɵngcc0.ɵɵtext(6, " Copy ");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.shareConfig.url, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("platform", ctx_r1.Platform.Copy)("title", ctx_r1.shareConfig.title)("url", ctx_r1.shareConfig.url)("description", ctx_r1.shareConfig.description)("open", ctx_r1.open);
} }
function FsShareButtonComponent_fs_share_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fs-share-icon", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("size", ctx_r0.iconSize ? ctx_r0.iconSize : ctx_r0.size / 100 * 20)("color", ctx_r0.color)("platform", ctx_r0.platform)("origin", ctx_r0.iconOrigin)("url", ctx_r0.iconUrl);
} }
const _c0 = function (a0, a1) { return { "font-size": a0, color: a1 }; };
function FsShareButtonComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(2, _c0, ctx_r1.size + "%", ctx_r1.color));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.platformNames[ctx_r1.platform], " ");
} }
const _c1 = function (a0) { return { "show-label": a0 }; };
function FsShareComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 1);
    ɵngcc0.ɵɵlistener("click", function FsShareComponent_a_0_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.click($event)); });
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.platform);
    ɵngcc0.ɵɵproperty("href", ctx_r0.safeHref, ɵngcc0.ɵɵsanitizeUrl);
} }
const _c2 = ["*"];
var Platform;
(function (Platform) {
    Platform["Facebook"] = "facebook";
    Platform["Twitter"] = "twitter";
    Platform["LinkedIn"] = "linkedin";
    Platform["WhatsApp"] = "whatsapp";
    Platform["Telegram"] = "telegram";
    Platform["Pinterest"] = "pinterest";
    Platform["Reddit"] = "reddit";
    Platform["Messenger"] = "messenger";
    Platform["Instagram"] = "instagram";
    Platform["Tumblr"] = "tumblr";
    Platform["Snapchat"] = "snapchat";
    Platform["TikTok"] = "tiktok";
    Platform["Copy"] = "copy";
    Platform["Email"] = "email";
    Platform["Any"] = "any";
})(Platform || (Platform = {}));

const Platforms = [
    { value: Platform.Facebook, name: 'Facebook', color: '#4267B2' },
    { value: Platform.Twitter, name: 'Twitter', color: '#0D0C0A' },
    { value: Platform.LinkedIn, name: 'LinkedIn', color: '#006fa6' },
    { value: Platform.Pinterest, name: 'Pinterest', color: '#E6001A' },
    { value: Platform.WhatsApp, name: 'WhatsApp', color: '#25D366' },
    { value: Platform.Reddit, name: 'Reddit', color: '#FF4006' },
    { value: Platform.Telegram, name: 'Telegram', color: '#0088cc' },
    { value: Platform.Messenger, name: 'Messenger', color: '#0080FF' },
    { value: Platform.Instagram, name: 'Instagram', color: '#FF6F91' },
    { value: Platform.Snapchat, name: 'Snapchat', color: '#F7F40D' },
    { value: Platform.TikTok, name: 'TikTok', color: '#0D0C0A' },
    { value: Platform.Tumblr, name: 'Tumblr', color: '#36465D' },
    { value: Platform.Email, name: 'Email', color: '#6067D0' },
    { value: Platform.Copy, name: 'Copy', color: '#607D8B' },
    { value: Platform.Any, name: 'Other', color: '#F2614A' },
];

class Share {
    constructor(config, deviceDetectorService) {
        this.navigatorShare = true;
        this.config = config;
        this._deviceDetectorService = deviceDetectorService;
    }
    getPlatformName() {
        const platform = Platforms.find((item) => {
            return item.value === this.platform;
        });
        return platform ? platform.name : '';
    }
    appSupported() {
        return true;
    }
    buildDecription() {
        return this.config.description;
    }
    buildTitle() {
        return this.config.title;
    }
    _createUrl(shareUrl, params) {
        const url = new URL(shareUrl);
        const data = {
            description: this.buildDecription(),
            title: this.buildTitle(),
            url: this.config.url,
            image: this.config.image
        };
        Object.keys(params)
            .forEach((key) => {
            const param = params[key];
            const value = data[key];
            if (value) {
                url.searchParams.append(param, value);
            }
            else {
                url.searchParams.append(key, param);
            }
        });
        return url;
    }
    open() {
        return new Observable((observer) => {
            const navigator = window.navigator;
            const shareData = {
                title: this.config.title,
                text: this.config.description,
                url: this.config.url,
            };
            if (this.navigatorShare && this._deviceDetectorService.isMobile() && navigator.canShare && navigator.canShare(shareData)) {
                navigator.share(shareData)
                    .then(() => {
                })
                    .catch((error) => {
                    console.log('Open Sharing Error', error);
                });
            }
            else {
                const w = window;
                const width = 800;
                const height = 500;
                const el = document.documentElement;
                const windowWidth = w.innerWidth ? w.innerWidth : el.clientWidth ? el.clientWidth : screen.width;
                const windowHeight = w.innerHeight ? w.innerHeight : el.clientHeight ? el.clientHeight : screen.height;
                const left = (windowWidth - width) / 2;
                const top = (windowHeight - height) / 2;
                const options = [
                    'width=' + width,
                    'height=' + height,
                    'top=' + top,
                    'left=' + left
                ];
                const windowProxy = window.open(this.createUrl().toString(), '_system', options.join(','));
                if (windowProxy) {
                    const timer = window.setInterval(() => {
                        if (windowProxy.closed !== false) {
                            window.clearInterval(timer);
                            observer.next(true);
                            observer.complete();
                        }
                    }, 200);
                    if (windowProxy && windowProxy.focus) {
                        windowProxy.focus();
                    }
                }
                else {
                    console.log('Failed to window.open');
                }
            }
        });
    }
    _cordovaPlatformSupported(platform) {
        return new Observable((observer) => {
            if (!window.plugins) {
                // on desktop, all share options avail.
                observer.error();
                observer.complete();
            }
            else {
                let domain = platform;
                if (window.device.platform === 'iOS') {
                    if (platform === 'facebook') {
                        domain = 'com.apple.social.facebook';
                    }
                    else if (platform === 'twitter') {
                        domain = 'com.apple.social.twitter';
                    }
                }
                else if (window.device.platform === 'Android') {
                    if (platform === 'facebook') {
                        domain = 'com.facebook.katana';
                    }
                    else if (platform === 'twitter') {
                        domain = 'com.twitter.android';
                    }
                }
                window.plugins.socialsharing.canShareVia(domain, 'msg', null, null, null, e => {
                    observer.next();
                    observer.complete();
                }, e => {
                    observer.error();
                    observer.complete();
                });
            }
        });
    }
}

var Method;
(function (Method) {
    Method[Method["Dialog"] = 0] = "Dialog";
    Method[Method["MetaRefesh"] = 1] = "MetaRefesh";
    Method[Method["Href"] = 2] = "Href";
})(Method || (Method = {}));

class AnyShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Any;
        this._webUrlParams = {};
        this._webUrl = '';
        this._appUrl = '';
    }
    createUrl() {
        return new URL('');
    }
    getMethod() {
        return Method.Dialog;
    }
    open() {
        return new Observable(observer => {
            if (!window.plugins || !window.plugins.socialsharing) {
                return observer.error('Any social sharing not available');
            }
            window.plugins.socialsharing.shareWithOptions({
                // message: shareConfig.title + (shareConfig.description ? ' - ' + shareConfig.description : ''),
                // subject: 'Shared from',
                // files: [shareConfig.image], // an array of filenames either locally or remotely
                url: this.config.url,
                chooserTitle: 'Pick an app' // Android only, you can override the default share sheet title
            }, response => {
                observer.next(response);
                observer.complete();
                // success
                // console.log('Share completed? ' + result.completed);
                // On Android apps mostly return false even while it's true
                // On Android result.app is currently empty.
                // On iOS it's empty when sharing is cancelled (result.completed=false)
                // console.log('Shared to app: ' + result.app);
            }, errormsg => {
                observer.error(errormsg);
            });
        });
    }
}

class FacebookShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Facebook;
        this.navigatorShare = false;
    }
    createUrl() {
        const url = 'https://www.facebook.com/sharer/sharer.php';
        const params = {
            url: 'u'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
    open() {
        return new Observable((observer) => {
            this._cordovaPlatformSupported(Platform.Facebook)
                .subscribe(() => {
                window.plugins.socialsharing.shareViaFacebook('', null, this.config.url, (response) => {
                    observer.next(response);
                    observer.complete();
                }, (errormsg) => {
                    observer.error(errormsg);
                });
            }, () => {
                super.open()
                    .subscribe((response) => {
                    observer.next(response);
                    observer.complete();
                });
            });
        });
    }
}

class TwitterShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Twitter;
    }
    createUrl() {
        const url = 'https://twitter.com/intent/tweet';
        const params = {
            url: 'url',
            description: 'text'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class LinkedInShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.LinkedIn;
    }
    createUrl() {
        const url = 'http://www.linkedin.com/shareArticle/?mini=true';
        const params = {
            url: 'url',
            title: 'title',
            description: 'summary'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class WhatsAppShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.WhatsApp;
    }
    createUrl() {
        const url = this.isMobile() ? 'whatsapp://send' : 'https://wa.me';
        const params = { description: 'text' };
        return this._createUrl(url, params);
    }
    getMethod() {
        return this.isMobile() ? Method.MetaRefesh : Method.Dialog;
    }
    buildDecription() {
        return this.config.description + '\n' + this.config.url;
    }
    isMobile() {
        return this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet();
    }
}

class TelegramShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Telegram;
    }
    createUrl() {
        const url = 'https://t.me/share/url';
        const params = {
            url: 'url',
            description: 'text'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class MessengerShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Messenger;
    }
    appSupported() {
        return this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet();
    }
    webSupported() {
        return false;
    }
    createUrl() {
        if (this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet()) {
            return this.createMobileUrl();
        }
        else {
            return this.createDesktopUrl();
        }
    }
    createDesktopUrl() {
        const url = 'http://www.facebook.com/dialog/send';
        const params = {
            //app_id: '140586622674265',
            redirect_uri: window.location.href,
            url: 'link'
        };
        return this._createUrl(url, params);
    }
    createMobileUrl() {
        const url = 'fb-messenger://share';
        const params = {
            url: 'link'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Href;
    }
}

class TumblrShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Tumblr;
    }
    createUrl() {
        const url = 'http://tumblr.com/widgets/share/tool';
        const params = {
            url: 'canonicalUrl',
            description: 'caption'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class CopyShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Copy;
    }
    createUrl() {
        return new URL('');
    }
    getMethod() {
        return null;
    }
}

class RedditShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Reddit;
    }
    createUrl() {
        const url = 'http://www.reddit.com/submit';
        const params = {
            url: 'url',
            description: 'text'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class PinterestShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Pinterest;
    }
    createUrl() {
        const url = 'https://www.pinterest.ca/pin/create/button/';
        const params = {
            url: 'url',
            image: 'media',
            description: 'description'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class InstagramShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Instagram;
    }
    appSupported() {
        return this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet();
    }
    webSupported() {
        return false;
    }
    createUrl() {
        const url = 'instagram://camera';
        const params = {};
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Href;
    }
}

class SnapchatShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.Snapchat;
    }
    createUrl() {
        const url = 'https://www.snapchat.com/scan';
        const params = {
            url: 'attachmentUrl'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Href;
    }
}

class EmailShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.LinkedIn;
    }
    createUrl() {
        const url = 'http://mailto:';
        const params = {
            url: 'url',
            title: 'title',
            description: 'summary'
        };
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Dialog;
    }
}

class TikTokShare extends Share {
    constructor() {
        super(...arguments);
        this.platform = Platform.TikTok;
    }
    appSupported() {
        return this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet();
    }
    webSupported() {
        return false;
    }
    createUrl() {
        const url = 'https://tiktok.com';
        const params = {};
        return this._createUrl(url, params);
    }
    getMethod() {
        return Method.Href;
    }
}

class ShareDialogComponent {
    constructor(_data, _dialogRef) {
        this._data = _data;
        this._dialogRef = _dialogRef;
        this.Platform = Platform;
        this.buttonPlatforms = [];
        this.copyPlatform = false;
        this.open = () => {
            this._dialogRef.close();
            return of(true);
        };
    }
    ngOnInit() {
        this.buttonPlatforms = this._data.platforms
            .filter((platform) => platform !== Platform.Copy);
        this.copyPlatform = this._data.platforms
            .some((platform) => platform === Platform.Copy);
        this.shareConfig = this._data.shareConfig;
    }
    copy() {
    }
}
ShareDialogComponent.ɵfac = function ShareDialogComponent_Factory(t) { return new (t || ShareDialogComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatDialogRef)); };
ShareDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ShareDialogComponent, selectors: [["ng-component"]], decls: 8, vars: 4, consts: [["mat-dialog-title", ""], ["class", "platforms", 4, "ngIf"], ["class", "copy-platform", 4, "ngIf"], ["mat-button", "", "color", "primary", "type", "button", 3, "mat-dialog-close"], [1, "platforms"], [3, "platform", "title", "url", "image", "size", "description", "showIcon", "showLabel", "open", "shape", 4, "ngFor", "ngForOf"], [3, "platform", "title", "url", "image", "size", "description", "showIcon", "showLabel", "open", "shape"], [1, "copy-platform"], [1, "box"], [1, "url"], [3, "platform", "title", "url", "description", "open"], ["mat-flat-button", "", "color", "primary", "type", "button"]], template: function ShareDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h2", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "mat-dialog-content");
        ɵngcc0.ɵɵtemplate(3, ShareDialogComponent_div_3_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(4, ShareDialogComponent_div_4_Template, 7, 6, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "mat-dialog-actions")(6, "button", 3);
        ɵngcc0.ɵɵtext(7, " Cancel ");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.shareConfig.dialogTitle || "Share");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonPlatforms.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.copyPlatform);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("mat-dialog-close", undefined);
    } }, dependencies: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc1.MatDialogClose, ɵngcc1.MatDialogTitle, ɵngcc1.MatDialogContent, ɵngcc1.MatDialogActions, ɵngcc3.MatButton, FsShareComponent, FsShareButtonComponent]; }, styles: [".platforms[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:center}h2[_ngcontent-%COMP%]{margin:0}.box[_ngcontent-%COMP%]{padding:6px 6px 6px 10px;border:1px solid #ddd;display:flex;align-items:center;border-radius:7px;margin-top:19px}.box[_ngcontent-%COMP%]   .url[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1;padding-right:10px}[_nghost-%COMP%]     .mat-dialog-content{width:500px;max-width:100%}"], changeDetection: 0 });
ShareDialogComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: MatDialogRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShareDialogComponent, [{
        type: Component,
        args: [{ template: "<h2 mat-dialog-title>{{shareConfig.dialogTitle || 'Share'}}</h2>\n<mat-dialog-content>\n  <div class=\"platforms\"\n      *ngIf=\"buttonPlatforms.length\">\n    <fs-share-button\n      *ngFor=\"let platform of buttonPlatforms\"\n      [platform]=\"platform\"\n      [title]=\"shareConfig.title\"\n      [url]=\"shareConfig.url\"\n      [image]=\"shareConfig.image\"\n      [size]=\"20\"\n      [description]=\"shareConfig.description\"\n      [showIcon]=\"true\"\n      [showLabel]=\"false\"\n      [open]=\"open\"\n      [size]=\"150\"\n      [shape]=\"'circle'\">\n    </fs-share-button>\n  </div>\n\n  <div class=\"copy-platform\"\n      *ngIf=\"copyPlatform\">\n    <div class=\"box\">\n      <div class=\"url\">\n        {{shareConfig.url}}\n      </div>\n      <fs-share\n          [platform]=\"Platform.Copy\"\n          [title]=\"shareConfig.title\"\n          [url]=\"shareConfig.url\"\n          [description]=\"shareConfig.description\"\n          [open]=\"open\">\n        <button\n            mat-flat-button\n            color=\"primary\"\n            type=\"button\">\n          Copy\n        </button>\n      </fs-share>\n    </div>\n  </div>\n\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button\n      mat-button\n      color=\"primary\"\n      type=\"button\"\n      [mat-dialog-close]=\"undefined\">\n    Cancel\n  </button>\n</mat-dialog-actions>", changeDetection: ChangeDetectionStrategy.OnPush, styles: [".platforms{display:flex;flex-wrap:wrap;justify-content:center}h2{margin:0}.box{padding:6px 6px 6px 10px;border:1px solid #ddd;display:flex;align-items:center;border-radius:7px;margin-top:19px}.box .url{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1;padding-right:10px}:host ::ng-deep .mat-dialog-content{width:500px;max-width:100%}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: ɵngcc1.MatDialogRef }]; }, null); })();

class FsShareService {
    constructor(_device, _dialog) {
        this._device = _device;
        this._dialog = _dialog;
    }
    createShare(platform, config) {
        switch (platform) {
            case Platform.Facebook:
                return new FacebookShare(config, this._device);
            case Platform.Twitter:
                return new TwitterShare(config, this._device);
            case Platform.LinkedIn:
                return new LinkedInShare(config, this._device);
            case Platform.WhatsApp:
                return new WhatsAppShare(config, this._device);
            case Platform.Telegram:
                return new TelegramShare(config, this._device);
            case Platform.Tumblr:
                return new TumblrShare(config, this._device);
            case Platform.Reddit:
                return new RedditShare(config, this._device);
            case Platform.Messenger:
                return new MessengerShare(config, this._device);
            case Platform.Pinterest:
                return new PinterestShare(config, this._device);
            case Platform.Instagram:
                return new InstagramShare(config, this._device);
            case Platform.TikTok:
                return new TikTokShare(config, this._device);
            case Platform.Snapchat:
                return new SnapchatShare(config, this._device);
            case Platform.Copy:
                return new CopyShare(config, this._device);
            case Platform.Email:
                return new EmailShare(config, this._device);
            case Platform.Any:
                return new AnyShare(config, this._device);
            default:
                throw 'Invalid platform: ' + platform;
        }
    }
    get platformNames() {
        if (!this._platformNames) {
            this._platformNames = Platforms.reduce((accum, value) => {
                return Object.assign(Object.assign({}, accum), { [value.value]: value.name });
            }, {});
        }
        return this._platformNames;
    }
    openDialog(platforms, shareConfig) {
        this._dialog.open(ShareDialogComponent, {
            data: {
                shareConfig,
                platforms,
            }
        });
    }
}
FsShareService.ɵfac = function FsShareService_Factory(t) { return new (t || FsShareService)(ɵngcc0.ɵɵinject(ɵngcc4.DeviceDetectorService), ɵngcc0.ɵɵinject(ɵngcc1.MatDialog)); };
FsShareService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FsShareService, factory: FsShareService.ɵfac });
FsShareService.ctorParameters = () => [
    { type: DeviceDetectorService },
    { type: MatDialog }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FsShareService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.DeviceDetectorService }, { type: ɵngcc1.MatDialog }]; }, null); })();

class FsShareButtonComponent {
    constructor(_shareService) {
        this._shareService = _shareService;
        this.description = '';
        this.title = '';
        this.url = '';
        this.image = '';
        this.showLabel = true;
        this.showIcon = true;
        this.iconOrigin = '';
        this.iconUrl = '';
        this.color = '#ffffff';
        this.shape = 'square';
        this.platformNames = [];
        this.platformNames = this._shareService.platformNames;
    }
}
FsShareButtonComponent.ɵfac = function FsShareButtonComponent_Factory(t) { return new (t || FsShareButtonComponent)(ɵngcc0.ɵɵdirectiveInject(FsShareService)); };
FsShareButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FsShareButtonComponent, selectors: [["fs-share-button"]], inputs: { description: "description", title: "title", url: "url", image: "image", showLabel: "showLabel", showIcon: "showIcon", iconOrigin: "iconOrigin", iconUrl: "iconUrl", color: "color", shape: "shape", platform: "platform", href: "href", beforeOpen: "beforeOpen", open: "open", iconSize: "iconSize", size: "size" }, decls: 4, vars: 23, consts: [[3, "title", "url", "image", "href", "description", "open", "beforeOpen", "platform"], [1, "button-container", 3, "ngClass"], ["class", "icon", 3, "size", "color", "platform", "origin", "url", 4, "ngIf"], ["class", "label", 3, "ngStyle", 4, "ngIf"], [1, "icon", 3, "size", "color", "platform", "origin", "url"], [1, "label", 3, "ngStyle"]], template: function FsShareButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "fs-share", 0)(1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, FsShareButtonComponent_fs_share_icon_2_Template, 1, 5, "fs-share-icon", 2);
        ɵngcc0.ɵɵtemplate(3, FsShareButtonComponent_span_3_Template, 2, 5, "span", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.title)("url", ctx.url)("image", ctx.image)("href", ctx.href)("description", ctx.description)("open", ctx.open)("beforeOpen", ctx.beforeOpen)("platform", ctx.platform);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.shape + " " + ctx.platform);
        ɵngcc0.ɵɵstyleProp("padding-top", ctx.size / 15 + "px")("padding-bottom", ctx.size / 15 + "px")("padding-left", ctx.size / 15 + (ctx.showLabel ? ctx.size / 15 : 0) + "px")("padding-right", ctx.size / 15 + (ctx.showLabel ? ctx.size / 15 : 0) + "px");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c1, ctx.showLabel));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLabel && ctx.platformNames[ctx.platform]);
    } }, dependencies: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgStyle, FsShareComponent, FsShareIconComponent]; }, styles: [".button-container[_ngcontent-%COMP%]{border-radius:4px;outline:none;font-family:inherit;border:none;cursor:pointer;display:inline-block;margin:5px;display:flex;align-items:center}.button-container[_ngcontent-%COMP%]   fs-share-icon[_ngcontent-%COMP%]{display:flex}.button-container.circle[_ngcontent-%COMP%]{border-radius:100%}.button-container.facebook[_ngcontent-%COMP%]{background-color:#4267b2}.button-container.twitter[_ngcontent-%COMP%]{background-color:#0d0c0a}.button-container.linkedin[_ngcontent-%COMP%]{background-color:#006fa6}.button-container.copy[_ngcontent-%COMP%]{background-color:#607d8b}.button-container.any[_ngcontent-%COMP%]{background-color:#f2614a}.button-container.whatsapp[_ngcontent-%COMP%]{background-color:#25d366}.button-container.telegram[_ngcontent-%COMP%]{background-color:#08c}.button-container.tumblr[_ngcontent-%COMP%]{background-color:#36465d}.button-container.messenger[_ngcontent-%COMP%]{background-color:#0080ff}.button-container.snapchat[_ngcontent-%COMP%]{background-color:#f7f40d}.button-container.reddit[_ngcontent-%COMP%]{background-color:#ff4006}.button-container.pinterest[_ngcontent-%COMP%]{background-color:#e6001a}.button-container.email[_ngcontent-%COMP%]{background-color:#6067d0}.button-container.tiktok[_ngcontent-%COMP%]{background-color:#0d0c0a}.button-container.instagram[_ngcontent-%COMP%]{background:#f09433;background:linear-gradient(45deg,#f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#f09433\",endColorstr=\"#bc1888\",GradientType=1)}.label[_ngcontent-%COMP%]{color:#fff;font-size:15px}.icon[_ngcontent-%COMP%] + .label[_ngcontent-%COMP%]{margin-left:9px}.icon[_ngcontent-%COMP%], .label[_ngcontent-%COMP%]{vertical-align:middle}"] });
FsShareButtonComponent.ctorParameters = () => [
    { type: FsShareService }
];
FsShareButtonComponent.propDecorators = {
    platform: [{ type: Input }],
    description: [{ type: Input }],
    title: [{ type: Input }],
    url: [{ type: Input }],
    image: [{ type: Input }],
    showLabel: [{ type: Input }],
    showIcon: [{ type: Input }],
    iconOrigin: [{ type: Input }],
    iconUrl: [{ type: Input }],
    color: [{ type: Input }],
    href: [{ type: Input }],
    beforeOpen: [{ type: Input }],
    open: [{ type: Input }],
    shape: [{ type: Input }],
    iconSize: [{ type: Input }],
    size: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FsShareButtonComponent, [{
        type: Component,
        args: [{ selector: 'fs-share-button', template: "<fs-share\n    [title]=\"title\"\n    [url]=\"url\"\n    [image]=\"image\"\n    [href]=\"href\"\n    [description]=\"description\"\n    [open]=\"open\"\n    [beforeOpen]=\"beforeOpen\"\n    [platform]=\"platform\">\n  <span \n      class=\"button-container\" \n      [class]=\"shape + ' ' + platform\" \n      [ngClass]=\"{ 'show-label': showLabel }\"      \n      [style.paddingTop]=\"((size / 15)) + 'px'\"\n      [style.paddingBottom]=\"((size / 15) ) + 'px'\"\n      [style.paddingLeft]=\"((size / 15) + (showLabel ? (size / 15) : 0)) + 'px'\"\n      [style.paddingRight]=\"((size / 15) + (showLabel ? (size / 15) : 0)) + 'px'\">\n    <fs-share-icon \n      class=\"icon\"\n      [size]=\"iconSize ? iconSize : (size / 100) * 20\"\n      *ngIf=\"showIcon\"\n      [color]=\"color\"\n      [platform]=\"platform\"\n      [origin]=\"iconOrigin\"\n      [url]=\"iconUrl\">\n    </fs-share-icon>\n    <span \n        class=\"label\" \n        *ngIf=\"showLabel && platformNames[platform]\" \n        [ngStyle]=\"{ 'font-size': size + '%', color: color }\">\n      {{platformNames[platform]}}\n    </span>\n </span>\n</fs-share>\n", styles: [".button-container{border-radius:4px;outline:none;font-family:inherit;border:none;cursor:pointer;display:inline-block;margin:5px;display:flex;align-items:center}.button-container fs-share-icon{display:flex}.button-container.circle{border-radius:100%}.button-container.facebook{background-color:#4267b2}.button-container.twitter{background-color:#0d0c0a}.button-container.linkedin{background-color:#006fa6}.button-container.copy{background-color:#607d8b}.button-container.any{background-color:#f2614a}.button-container.whatsapp{background-color:#25d366}.button-container.telegram{background-color:#08c}.button-container.tumblr{background-color:#36465d}.button-container.messenger{background-color:#0080ff}.button-container.snapchat{background-color:#f7f40d}.button-container.reddit{background-color:#ff4006}.button-container.pinterest{background-color:#e6001a}.button-container.email{background-color:#6067d0}.button-container.tiktok{background-color:#0d0c0a}.button-container.instagram{background:#f09433;background:linear-gradient(45deg,#f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#f09433\",endColorstr=\"#bc1888\",GradientType=1)}.label{color:#fff;font-size:15px}.icon+.label{margin-left:9px}.icon,.label{vertical-align:middle}\n"] }]
    }], function () { return [{ type: FsShareService }]; }, { description: [{
            type: Input
        }], title: [{
            type: Input
        }], url: [{
            type: Input
        }], image: [{
            type: Input
        }], showLabel: [{
            type: Input
        }], showIcon: [{
            type: Input
        }], iconOrigin: [{
            type: Input
        }], iconUrl: [{
            type: Input
        }], color: [{
            type: Input
        }], shape: [{
            type: Input
        }], platform: [{
            type: Input
        }], href: [{
            type: Input
        }], beforeOpen: [{
            type: Input
        }], open: [{
            type: Input
        }], iconSize: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();

class FsShareComponent {
    constructor(_shareService, _sanitizer) {
        this._shareService = _shareService;
        this._sanitizer = _sanitizer;
        this.description = '';
        this.title = '';
        this.url = '';
        this.image = '';
        this.href = '';
        this.platformNames = {};
        this.show = true;
        this._destory$ = new Subject();
        this.platformNames = Platforms.reduce((result, value) => {
            result[value.value] = value.name;
            return result;
        }, {});
    }
    click(event) {
        event.preventDefault();
        of(true)
            .pipe(switchMap(() => {
            const result = this.beforeOpen ? this.beforeOpen({ platform: this.platform }) : true;
            return result instanceof Observable ? result : of(true);
        }), filter((result) => !!result), switchMap(() => {
            const result = this.open ? this.open({ platform: this.platform }) : true;
            return result instanceof Observable ? result : of(true);
        }), filter((result) => !!result), takeUntil(this._destory$))
            .subscribe(() => {
            if (this.platform === Platform.Copy) {
                navigator.clipboard.writeText(this._share.config.url);
            }
            else if (this._share.getMethod() === Method.MetaRefesh) {
                this._metaRefresh();
            }
            else if (this._share.getMethod() === Method.Dialog) {
                this._dialog();
            }
            else if (this._share.getMethod() === Method.Href) {
                location.href = this.href;
            }
        });
    }
    _metaRefresh() {
        const newWindow = window.open('', 'Share', 'width=1,height=1');
        const url = this._share.createUrl().toString();
        const html = `
    <html>
      <head>
        <meta http-equiv="refresh" content="0;url=` + url + `">
      </head>
      <body></body>
      <script>setTimeout(function() { window.close() }, 1000);</script>
    </html>`;
        newWindow.document.open();
        newWindow.document.write(html);
        newWindow.document.close();
        setTimeout(() => {
            if (newWindow) {
                newWindow.close();
            }
        }, 500);
    }
    ngOnInit() {
        const config = {
            url: this.url,
            description: this.description,
            title: this.title,
            image: this.image
        };
        this._share = this._shareService.createShare(this.platform, config);
        if (this._share.getMethod() === Method.Href && !this.href) {
            this.href = this._share.createUrl().toString();
        }
        if (this.href) {
            this.safeHref = this._sanitizer.bypassSecurityTrustUrl(this.href);
        }
        else {
            this.href = 'javascript:;';
        }
    }
    _dialog() {
        this._share.open()
            .pipe(takeUntil(this._destory$))
            .subscribe(response => {
            // if (this.config.success) {
            //   this.config.success({ platform: this.platform });
            // }
        }, (error) => {
            // if (this.config.error) {
            //   this.config.error({ platform: this.platform, error: error });
            // }
        });
    }
    ngOnDestroy() {
        this._destory$.next();
        this._destory$.complete();
    }
}
FsShareComponent.ɵfac = function FsShareComponent_Factory(t) { return new (t || FsShareComponent)(ɵngcc0.ɵɵdirectiveInject(FsShareService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
FsShareComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FsShareComponent, selectors: [["fs-share"]], inputs: { description: "description", title: "title", url: "url", image: "image", href: "href", platform: "platform", beforeOpen: "beforeOpen", open: "open" }, ngContentSelectors: _c2, decls: 1, vars: 1, consts: [[3, "class", "href", "click", 4, "ngIf"], [3, "href", "click"]], template: function FsShareComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FsShareComponent_a_0_Template, 2, 3, "a", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, dependencies: [ɵngcc2.NgIf], encapsulation: 2 });
FsShareComponent.ctorParameters = () => [
    { type: FsShareService },
    { type: DomSanitizer }
];
FsShareComponent.propDecorators = {
    platform: [{ type: Input }],
    description: [{ type: Input }],
    title: [{ type: Input }],
    url: [{ type: Input }],
    image: [{ type: Input }],
    href: [{ type: Input }],
    beforeOpen: [{ type: Input }],
    open: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FsShareComponent, [{
        type: Component,
        args: [{
                selector: 'fs-share',
                template: "<a\n    *ngIf=\"show\"\n    [class]=\"platform\"\n    [href]=\"safeHref\"\n    (click)=\"click($event)\">\n  <ng-content></ng-content>\n</a>"
            }]
    }], function () { return [{ type: FsShareService }, { type: ɵngcc5.DomSanitizer }]; }, { description: [{
            type: Input
        }], title: [{
            type: Input
        }], url: [{
            type: Input
        }], image: [{
            type: Input
        }], href: [{
            type: Input
        }], platform: [{
            type: Input
        }], beforeOpen: [{
            type: Input
        }], open: [{
            type: Input
        }] }); })();

class Color {
    constructor(r, g, b) {
        this.r = 0;
        this.g = 0;
        this.b = 0;
        this.set(r, g, b);
    }
    set(r, g, b) {
        this.r = this.clamp(r);
        this.g = this.clamp(g);
        this.b = this.clamp(b);
    }
    /**
     * Applying cals to get CSS filter for hue-rotate
     *
     * @param {number} [angle=0]
     * @memberof Color
     */
    hueRotate(angle = 0) {
        angle = (angle / 180) * Math.PI;
        const sin = Math.sin(angle);
        const cos = Math.cos(angle);
        this.multiply([
            0.213 + cos * 0.787 - sin * 0.213,
            0.715 - cos * 0.715 - sin * 0.715,
            0.072 - cos * 0.072 + sin * 0.928,
            0.213 - cos * 0.213 + sin * 0.143,
            0.715 + cos * 0.285 + sin * 0.14,
            0.072 - cos * 0.072 - sin * 0.283,
            0.213 - cos * 0.213 - sin * 0.787,
            0.715 - cos * 0.715 + sin * 0.715,
            0.072 + cos * 0.928 + sin * 0.072,
        ]);
    }
    /**
     * Applying cals to get CSS filter for grayscale
     *
     * @param {number} [value=1]
     * @memberof Color
     */
    grayscale(value = 1) {
        this.multiply([
            0.2126 + 0.7874 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 + 0.2848 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 + 0.9278 * (1 - value),
        ]);
    }
    /**
     * Applying cals to get CSS filter for sepia
     *
     * @param {number} [value=1]
     * @memberof Color
     */
    sepia(value = 1) {
        this.multiply([
            0.393 + 0.607 * (1 - value),
            0.769 - 0.769 * (1 - value),
            0.189 - 0.189 * (1 - value),
            0.349 - 0.349 * (1 - value),
            0.686 + 0.314 * (1 - value),
            0.168 - 0.168 * (1 - value),
            0.272 - 0.272 * (1 - value),
            0.534 - 0.534 * (1 - value),
            0.131 + 0.869 * (1 - value),
        ]);
    }
    /**
     * Applying cals to get CSS filter for saturate
     *
     * @param {number} [value=1]
     * @memberof Color
     */
    saturate(value = 1) {
        this.multiply([
            0.213 + 0.787 * value,
            0.715 - 0.715 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 + 0.285 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 - 0.715 * value,
            0.072 + 0.928 * value,
        ]);
    }
    multiply(matrix) {
        // These values are needed. It's correct because the returned values will change
        const newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
        const newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
        const newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
        this.r = newR;
        this.g = newG;
        this.b = newB;
    }
    /**
     * Applying cals to get CSS filter for brightness
     *
     * @param {number} [value=1]
     * @memberof Color
     */
    brightness(value = 1) {
        this.linear(value);
    }
    /**
     * Applying cals to get CSS filter for contrast
     *
     * @param {number} [value=1]
     * @memberof Color
     */
    contrast(value = 1) {
        this.linear(value, -(0.5 * value) + 0.5);
    }
    linear(slope = 1, intercept = 0) {
        this.r = this.clamp(this.r * slope + intercept * 255);
        this.g = this.clamp(this.g * slope + intercept * 255);
        this.b = this.clamp(this.b * slope + intercept * 255);
    }
    /**
     * Applying cals to get CSS filter for invert
     *
     * @param {number} [value=1]
     * @memberof Color
     */
    invert(value = 1) {
        this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
        this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
        this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
    }
    /**
     * transform RGB into HSL values
     *
     * @returns {HSLData}
     * @memberof Color
     */
    hsl() {
        const red = this.r / 255;
        const green = this.g / 255;
        const blue = this.b / 255;
        // find greatest and smallest channel values
        const max = Math.max(red, green, blue);
        const min = Math.min(red, green, blue);
        let hue = 0;
        let saturation = 0;
        const lightness = (max + min) / 2;
        // If min and max have the same values, it means
        // the given color is achromatic
        if (max === min) {
            return {
                h: 0,
                s: 0,
                l: lightness * 100,
            };
        }
        // Adding delta value of greatest and smallest channel values
        const delta = max - min;
        saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
        if (max === red) {
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
        }
        else if (max === green) {
            hue = (blue - red) / delta + 2;
        }
        else if (max === blue) {
            hue = (red - green) / delta + 4;
        }
        hue /= 6;
        return {
            h: hue * 100,
            s: saturation * 100,
            l: lightness * 100,
        };
    }
    /**
     * Normalize the value to follow the min and max for RGB colors
     * min: 0
     * max: 255
     *
     * @private
     * @param {number} value
     * @returns {number}
     * @memberof Color
     */
    clamp(value) {
        // Minimum RGB Value = 0;
        // Maximum RGB Value = 255;
        return Math.min(Math.max(value, 0), 255);
    }
}

class Solver {
    constructor(target, options) {
        this.target = target;
        this.targetHSL = target.hsl();
        this.options = Object.assign({}, 
        // Adding default values for options
        {
            acceptanceLossPercentage: 5,
            maxChecks: 15,
        }, options);
        // All the calcs done by the library to generate
        // a CSS Filter are based on the color `#000`
        // in this case, `rgb(0, 0, 0)`
        // Please make sure the background of the element
        // is `#000` for better performance
        // and color similarity.
        this.reusedColor = new Color(0, 0, 0);
    }
    /**
     * Returns the solved values for the
     *
     * @returns {(SPSAPayload & { filter: string; })}
     * @memberof Solver
     */
    solve() {
        const result = this.solveNarrow(this.solveWide());
        return {
            values: result.values,
            called: result.called,
            loss: result.loss,
            filter: this.css(result.values),
        };
    }
    /**
     * Solve wide values based on the wide values for RGB and HSL values
     *
     * @private
     * @returns {SPSAPayload}
     * @memberof Solver
     */
    solveWide() {
        const A = 5;
        const c = 15;
        // Wide values for RGB and HSL values
        // the values in the order: [`r`, `g`, `b`, `h`, `s`, `l`]
        const a = [60, 180, 18000, 600, 1.2, 1.2];
        let best = { loss: Infinity };
        let counter = 0;
        while (best.loss > this.options.acceptanceLossPercentage) {
            const initialFilterValues = [50, 20, 3750, 50, 100, 100];
            const result = this.spsa({
                A,
                a,
                c,
                values: initialFilterValues,
                // for wide values we should use the double of tries in
                // comparison of `solveNarrow()` method
                maxTriesInLoop: 1000,
            });
            if (result.loss < best.loss) {
                best = result;
            }
            counter += 1;
            if (counter >= this.options.maxChecks) {
                break;
            }
        }
        return Object.assign({}, best, { called: counter });
    }
    /**
     * Solve narrow values based on the wide values for the filter
     *
     * @private
     * @param {SPSAPayload} wide
     * @returns {SPSAPayload}
     * @memberof Solver
     */
    solveNarrow(wide) {
        const A = wide.loss;
        const c = 2;
        const A1 = A + 1;
        // Narrow values for RGB and HSL values
        // the values in the order: [`r`, `g`, `b`, `h`, `s`, `l`]
        const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
        return this.spsa({
            A,
            a,
            c,
            values: wide.values,
            maxTriesInLoop: 500,
            called: wide.called,
        });
    }
    /**
     * Returns final value based on the current filter order
     * to get the order, please check the returned value
     * in `css()` method
     *
     * @private
     * @param {number} value
     * @param {number} idx
     * @returns {number}
     * @memberof Solver
     */
    fixValueByFilterIDX(value, idx) {
        let max = 100;
        // Fixing max, minimum and value by filter
        if (idx === 2 /* saturate */) {
            max = 7500;
        }
        else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
            max = 200;
        }
        if (idx === 3 /* hue-rotate */) {
            if (value > max) {
                value %= max;
            }
            else if (value < 0) {
                value = max + (value % max);
            }
        }
        // Checking if value is below the minimum or above
        // the maximum allowed by filter
        else if (value < 0) {
            value = 0;
        }
        else if (value > max) {
            value = max;
        }
        return value;
    }
    spsa({ A, a, c, values, maxTriesInLoop = 500, called = 0, }) {
        const alpha = 1;
        const gamma = 0.16666666666666666;
        let best = null;
        let bestLoss = Infinity;
        const deltas = new Array(6);
        const highArgs = new Array(6);
        const lowArgs = new Array(6);
        // Size of all CSS filters to be applied to get the correct color
        const filtersToBeAppliedSize = 6;
        for (let key = 0; key < maxTriesInLoop; key++) {
            const ck = c / Math.pow(key + 1, gamma);
            for (let i = 0; i < filtersToBeAppliedSize; i++) {
                deltas[i] = Math.random() > 0.5 ? 1 : -1;
                highArgs[i] = values[i] + ck * deltas[i];
                lowArgs[i] = values[i] - ck * deltas[i];
            }
            const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
            for (let i = 0; i < filtersToBeAppliedSize; i++) {
                const g = (lossDiff / (2 * ck)) * deltas[i];
                const ak = a[i] / Math.pow(A + key + 1, alpha);
                values[i] = this.fixValueByFilterIDX(values[i] - ak * g, i);
            }
            const loss = this.loss(values);
            if (loss < bestLoss) {
                best = values.slice(0);
                bestLoss = loss;
            }
        }
        return { values: best, loss: bestLoss, called };
    }
    /**
     * Checks how much is the loss for the filter in RGB and HSL colors
     *
     * @private
     * @param {SPSAPayload['values']} filters
     * @returns {number}
     * @memberof Solver
     */
    loss(filters) {
        // Argument as an Array of percentages.
        const color = this.reusedColor;
        // Resetting the color to black in case
        // it was called more than once
        color.set(255, 255, 255);
        color.invert(filters[0] / 100);
        color.sepia(filters[1] / 100);
        color.saturate(filters[2] / 100);
        color.hueRotate(filters[3] * 3.6);
        color.brightness(filters[4] / 100);
        color.contrast(filters[5] / 100);
        const colorHSL = color.hsl();
        return (Math.abs(color.r - this.target.r) +
            Math.abs(color.g - this.target.g) +
            Math.abs(color.b - this.target.b) +
            Math.abs(colorHSL.h - this.targetHSL.h) +
            Math.abs(colorHSL.s - this.targetHSL.s) +
            Math.abs(colorHSL.l - this.targetHSL.l));
    }
    /**
     * Returns the CSS filter list for the received HEX color
     *
     * @private
     * @param {number[]} filters
     * @returns {string}
     * @memberof Solver
     */
    css(filters) {
        const formatCssFilterValueByMultiplier = (idx, multiplier = 1) => Math.round(filters[idx] * multiplier);
        return [
            `invert(${formatCssFilterValueByMultiplier(0)}%)`,
            `sepia(${formatCssFilterValueByMultiplier(1)}%)`,
            `saturate(${formatCssFilterValueByMultiplier(2)}%)`,
            `hue-rotate(${formatCssFilterValueByMultiplier(3, 3.6)}deg)`,
            `brightness(${formatCssFilterValueByMultiplier(4)}%)`,
            `contrast(${formatCssFilterValueByMultiplier(5)}%);`,
        ].join(' ');
    }
}

/**
 * Transform a CSS Color from Hexadecimal to RGB color
 *
 * @param {string} hex hexadecimal color
 * @returns {([number, number, number] | [])} array with the RGB colors or empty array
 */
const hexToRgb = (hex) => {
    if (hex.length === 4) {
        return [parseInt(`0x${hex[1]}${hex[1]}`), parseInt(`0x${hex[2]}${hex[2]}`), parseInt(`0x${hex[3]}${hex[3]}`)];
    }
    if (hex.length === 7) {
        return [parseInt(`0x${hex[1]}${hex[2]}`), parseInt(`0x${hex[3]}${hex[4]}`), parseInt(`0x${hex[5]}${hex[6]}`)];
    }
    return [];
};
const ɵ0 = hexToRgb;
const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);
const ɵ1 = isNumeric;
// Memory cache for the computed results to avoid multiple
// calculations for the same color
let results = {};
/**
 * A function that transforms a HEX color into CSS filters
 *
 * @param colorValue string hexadecimal color
 * @param opts HexToCssConfiguration function configuration
 *
 */
const hexToCSSFilter = (colorValue, opts = {}) => {
    let red;
    let green;
    let blue;
    if (results[colorValue] && !opts.forceFilterRecalculation) {
        return Object.assign({}, results[colorValue], { cache: true });
    }
    let color;
    try {
        [red, green, blue] = hexToRgb(colorValue);
        if (!isNumeric(red) || !isNumeric(green) || !isNumeric(blue)) {
            throw new Error(`hextToRgb returned an invalid value for '${colorValue}'`);
        }
        color = new Color(Number(red), Number(green), Number(blue));
    }
    catch (error) {
        throw new Error(`Color value should be in HEX format. ${error}`);
    }
    const solver = new Solver(color, Object.assign({}, 
    // `HexToCssConfiguration` Defaults
    {
        acceptanceLossPercentage: 5,
        maxChecks: 30,
        forceFilterRecalculation: false,
    }, opts));
    return (results[colorValue] = Object.assign({}, solver.solve(), {
        hex: colorValue,
        rgb: [red, green, blue],
        cache: false,
    }));
};
/**
 * A function that clears cached results
 *
 * @param  {string} key? HEX string value passed previously `#24639C`. If not passed, it clears all cached results
 * @returns void
 */
const clearCache = (key) => {
    if (!key) {
        results = {};
    }
    else if (results[key]) {
        delete results[key];
    }
};

class FsShareIconComponent {
    constructor(_sanitizer, _cdRef, _el) {
        this._sanitizer = _sanitizer;
        this._cdRef = _cdRef;
        this._el = _el;
        this.size = 20;
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        if (!this.color) {
            const platform = Platforms.find((item) => {
                return item.value === this.platform;
            });
            if (platform) {
                this.setColor(platform.color);
            }
        }
    }
    get svgUrl() {
        if (this.url) {
            return this.url;
        }
        const url = new URL(`/assets/@firestitch/share/${this.platform}.svg`, this.origin || location.origin);
        return url.toString();
    }
    get dataUrl() {
        return this._sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
    ngOnChanges(changes) {
        var _a;
        if ((_a = changes.color) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.setColor(changes.color.currentValue);
        }
    }
    setColor(hex) {
        const cssFilter = hexToCSSFilter(hex);
        const filter = cssFilter.filter.replace(/;$/is, '');
        this._el.nativeElement.style.setProperty('--icon-filter', filter);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
FsShareIconComponent.ɵfac = function FsShareIconComponent_Factory(t) { return new (t || FsShareIconComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FsShareIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FsShareIconComponent, selectors: [["fs-share-icon"]], inputs: { size: "size", platform: "platform", color: "color", origin: "origin", url: "url" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 5, consts: [[3, "src"]], template: function FsShareIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "img", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("height", ctx.size + "px")("width", ctx.size + "px");
        ɵngcc0.ɵɵproperty("src", ctx.svgUrl, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: ["img[_ngcontent-%COMP%]{filter:var(--icon-filter)}"], changeDetection: 0 });
FsShareIconComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
FsShareIconComponent.propDecorators = {
    platform: [{ type: Input }],
    size: [{ type: Input }],
    color: [{ type: Input }],
    origin: [{ type: Input }],
    url: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FsShareIconComponent, [{
        type: Component,
        args: [{ selector: 'fs-share-icon', template: "<img \n  [style.height]=\"size + 'px'\"\n  [style.width]=\"size + 'px'\"\n  [src]=\"svgUrl\">", changeDetection: ChangeDetectionStrategy.OnPush, styles: ["img{filter:var(--icon-filter)}\n"] }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { size: [{
            type: Input
        }], platform: [{
            type: Input
        }], color: [{
            type: Input
        }], origin: [{
            type: Input
        }], url: [{
            type: Input
        }] }); })();

class FsShareModule {
    static forRoot() {
        return {
            ngModule: FsShareModule,
            providers: [FsShareService]
        };
    }
}
FsShareModule.ɵfac = function FsShareModule_Factory(t) { return new (t || FsShareModule)(); };
FsShareModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FsShareModule });
FsShareModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DeviceDetectorService,
    ], imports: [CommonModule,
        MatDialogModule,
        MatButtonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FsShareModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatDialogModule,
                    MatButtonModule,
                ],
                exports: [
                    FsShareComponent,
                    FsShareButtonComponent,
                    FsShareIconComponent,
                ],
                declarations: [
                    FsShareComponent,
                    FsShareButtonComponent,
                    FsShareIconComponent,
                    ShareDialogComponent,
                ],
                providers: [
                    DeviceDetectorService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FsShareModule, { declarations: function () { return [FsShareComponent, FsShareButtonComponent, FsShareIconComponent, ShareDialogComponent]; }, imports: function () { return [CommonModule,
        MatDialogModule,
        MatButtonModule]; }, exports: function () { return [FsShareComponent, FsShareButtonComponent, FsShareIconComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { FsShareButtonComponent, FsShareComponent, FsShareIconComponent, FsShareModule, FsShareService, Platform, Platforms, ShareDialogComponent as ɵa };

